module.exports = __webpack_public_path__ + "img/bg6.16e85c66.png";